interface ISelectBoxUsageEvents {
  root: string;
}

export const SelectBoxUsageEvents: ISelectBoxUsageEvents = {
  root: 'SPark.Registration.SelectBox',
};
